/* eslint-disable import/prefer-default-export */

module.exports = Object.freeze({
  MEDIA_GET_REQUEST: 'MEDIA_GET_REQUEST',
  MEDIA_GET_SUCCESS: 'MEDIA_GET_SUCCESS',
  MEDIA_GET_FAIL: 'MEDIA_GET_FAIL',
  CLEAR_PLAYER: 'CLEAR_PLAYER',
  CLEAR_SETTINGS: 'CLEAR_SETTINGS',
  TAG_POST_REQUEST: 'TAG_POST_REQUEST',
  TAG_POST_SUCCESS: 'TAG_POST_SUCCESS',
  TAG_POST_FAIL: 'TAG_POST_FAIL',
  GET_REQUEST: 'GET_REQUEST',
  GET_SUCCESS: 'GET_SUCCESS',
  GET_FAIL: 'GET_FAIL',
  REVIEW_SEARCH_REQUEST: 'REVIEW_SEARCH_REQUEST',
  REVIEW_SEARCH_SUCCESS: 'REVIEW_SEARCH_SUCCESS',
  REVIEW_SEARCH_FAIL: 'REVIEW_SEARCH_FAIL',
  REVIEW_GET_REQUEST: 'REVIEW_GET_REQUEST',
  REVIEW_GET_SUCCESS: 'REVIEW_GET_SUCCESS',
  REVIEW_GET_FAIL: 'REVIEW_GET_FAIL',
  REVIEW_POST_REQUEST: 'REVIEW_POST_REQUEST',
  REVIEW_POST_SUCCESS: 'REVIEW_POST_SUCCESS',
  REVIEW_HIDE_SUCCESS: 'REVIEW_HIDE_SUCCESS',
  REVIEW_POST_FAIL: 'REVIEW_POST_FAIL',
  COACH_GET_REQUEST: 'COACH_GET_REQUEST',
  COACH_GET_SUCCESS: 'COACH_GET_SUCCESS',
  COACH_GET_FAIL: 'COACH_GET_FAIL',
  COACH_SET_REQUEST: 'COACH_SET_REQUEST',
  COACH_SET_SUCCESS: 'COACH_SET_SUCCESS',
  COACH_SET_FAIL: 'COACH_SET_FAIL',
  USER_INFO_REQUEST: 'GET_USERINFO_REQUEST',
  USER_INFO_SUCCESS: 'GET_USERINFO_SUCCESS',
  USER_INFO_FAIL: 'GET_USERINFO_FAIL',
  COMMENTS_GET_REQUEST: 'COMMENTS_GET_REQUEST',
  COMMENTS_GET_SUCCESS: 'COMMENTS_GET_SUCCESS',
  COMMENTS_GET_FAIL: 'COMMENTS_GET_FAIL',
  COMMENTS_POST_SUCCESS: 'COMMENTS_POST_SUCCESS',
  COMMENTS_DELETE_SUCCESS: 'COMMENTS_DELETE_SUCCESS',
  LIBRARY_VIEW_SAVE: 'LIBRARY_VIEW_SAVE',
  LOCK_MEDIA: 'LOCK_MEDIA',
  UNLOCK_MEDIA: 'UNLOCK_MEDIA',
  MEDIA_FLAG_UPDATE: 'MEDIA_FLAG_UPDATE'
});
